import { getStaticSeoPage } from "../lib/staticSeoRegistry";

export const USEFUL_SERVICES_LAST_VERIFIED = "2026-08-08";
export const USEFUL_SERVICES_OFFICIAL_HELP_LAST_VERIFIED = "2026-09-04";
export const USEFUL_SERVICES_REVIEW_WINDOW_DAYS = 90;

const BENALMADENA_COUNCIL_MARKETS_SOURCE =
  "https://www.benalmadena.es/contenido.php?m=benalmadena-delegaciones&s=delegacion-de-comercio";
const ANDALUCIA_EMERGENCY_112_SOURCE =
  "https://www.juntadeandalucia.es/organismos/ema/areas/emergencias-112.html";
const ANDALUCIA_SALUD_RESPONDE_SOURCE =
  "https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ciudadania/salud-responde";
const BENALMADENA_TOURISM_SOURCE = "https://turismo.benalmadena.es/";

export const USEFUL_SERVICE_CATEGORIES = [
  {
    id: "bus",
    label: "Bus",
    shortLabel: "Bus",
    icon: "🚌",
    path: "/benalmadena-bus-times",
    destination: "Benalmádena",
  },
  {
    id: "train",
    label: "Train",
    shortLabel: "Train",
    icon: "🚆",
    path: "/benalmadena-train-times",
    destination: "Benalmádena",
  },
  {
    id: "taxi",
    label: "Taxi",
    shortLabel: "Taxi",
    icon: "🚕",
    path: "/benalmadena-taxis",
    destination: "Benalmádena",
  },
  {
    id: "airport",
    label: "Málaga Airport",
    shortLabel: "Airport",
    icon: "✈️",
    path: "/benalmadena-to-malaga-airport",
    destination: "Málaga Airport",
  },
  {
    id: "pharmacy",
    label: "Pharmacy",
    shortLabel: "Pharmacy",
    icon: "💊",
    path: "/pharmacies-benalmadena",
    destination: "Benalmádena",
  },
  {
    id: "medical",
    label: "Medical Help",
    shortLabel: "Medical",
    icon: "🏥",
    path: "/medical-help-benalmadena",
    destination: "Benalmádena",
  },
  {
    id: "emergency",
    label: "Emergency Help",
    shortLabel: "Emergency",
    icon: "🆘",
    path: "/emergency-help-benalmadena",
    destination: "Benalmádena",
  },
  {
    id: "weather",
    label: "Weather",
    shortLabel: "Weather",
    icon: "☀️",
    path: "/benalmadena-weather",
    destination: "Benalmádena",
  },
  {
    id: "markets",
    label: "Markets / Market Days",
    shortLabel: "Markets",
    icon: "🛍️",
    path: "/markets-benalmadena",
    destination: "Benalmádena",
  },
  {
    id: "tourist-info",
    label: "Tourist Information",
    shortLabel: "Tourist Info",
    icon: "ℹ️",
    path: "/tourist-information-benalmadena",
    destination: "Benalmádena",
  },
];

export const BENALMADENA_MARKETS = [
  {
    id: "benalmadena-friday-street-market",
    name: "Benalmádena Friday Street Market",
    shortName: "Friday Street Market",
    destination: "Benalmádena",
    dayLabel: "Fridays",
    weekdays: [5],
    hours: "09:00-14:00",
    location: "Explanada de Tívoli, Avenida del Manantial, Arroyo de la Miel",
    type: "General street market",
    summary:
      "Textiles, ceramics, food and mixed goods at the Explanada de Tívoli area in Arroyo de la Miel.",
    directionsUrl:
      "https://www.google.com/maps/search/?api=1&query=Explanada%20de%20Tivoli%20Avenida%20del%20Manantial%20Arroyo%20de%20la%20Miel",
    officialSourceLabel: "Benalmádena council commerce information",
    officialSourceUrl: BENALMADENA_COUNCIL_MARKETS_SOURCE,
  },
  {
    id: "la-paloma-friday-produce-market",
    name: "La Paloma Friday Fruit and Vegetable Market",
    shortName: "Friday Produce Market",
    destination: "Benalmádena",
    dayLabel: "Fridays",
    weekdays: [5],
    hours: "09:00-14:00",
    location: "Recinto Ferial La Paloma, Arroyo de la Miel",
    type: "Fruit and vegetable market",
    summary:
      "Friday produce market focused on fruit and vegetables at Recinto Ferial La Paloma.",
    directionsUrl:
      "https://www.google.com/maps/search/?api=1&query=Recinto%20Ferial%20La%20Paloma%20Arroyo%20de%20la%20Miel",
    officialSourceLabel: "Benalmádena council commerce information",
    officialSourceUrl: BENALMADENA_COUNCIL_MARKETS_SOURCE,
  },
  {
    id: "la-paloma-wednesday-flea-market",
    name: "Benalmádena Wednesday Flea Market",
    shortName: "Wednesday Flea Market",
    destination: "Benalmádena",
    dayLabel: "Wednesdays",
    weekdays: [3],
    hours: "09:00-14:00",
    location: "Recinto Ferial La Paloma, Arroyo de la Miel",
    type: "Flea market / second-hand market",
    summary:
      "Second-hand goods market at Recinto Ferial La Paloma. Good for browsing rather than guaranteed product availability.",
    directionsUrl:
      "https://www.google.com/maps/search/?api=1&query=Recinto%20Ferial%20La%20Paloma%20Arroyo%20de%20la%20Miel",
    officialSourceLabel: "Benalmádena council commerce information",
    officialSourceUrl: BENALMADENA_COUNCIL_MARKETS_SOURCE,
  },
  {
    id: "guadalhorce-ecological-market-benalmadena",
    name: "Guadalhorce Ecological Market Benalmádena",
    shortName: "Ecological Market",
    destination: "Benalmádena",
    dayLabel: "Third Sunday of each month",
    weekdays: [0],
    recurrence: "third_sunday",
    hours: "09:00-14:00",
    location: "Recinto Ferial La Paloma, Arroyo de la Miel",
    type: "Ecological / organic market",
    summary:
      "Itinerant ecological market listed by the council for the third Sunday of each month at Recinto Ferial La Paloma.",
    directionsUrl:
      "https://www.google.com/maps/search/?api=1&query=Recinto%20Ferial%20La%20Paloma%20Arroyo%20de%20la%20Miel",
    officialSourceLabel: "Benalmádena council commerce information",
    officialSourceUrl: BENALMADENA_COUNCIL_MARKETS_SOURCE,
  },
];

const USEFUL_SERVICE_CONTENT = [
  {
    id: "overview",
    path: "/useful-services",
    h1: "Useful Services in Benalmádena",
    eyebrow: "Tourist basics",
    intro: "Everything you need while you're here: transport, airport links, pharmacies, medical help, weather and local market days.",
    answer:
      "Start here for practical Benalmádena visitor information. Vibe2Nite gives quick guidance and links out to official sources for live times, pharmacy duty information, emergency help, weather changes and market updates.",
    quickSteps: [
      "Pick the service you need: transport, medical help, emergency info, weather or markets.",
      "Use Vibe2Nite for plain-English context before opening official live sources.",
      "For urgent medical or safety situations, use official emergency services first.",
    ],
    sourceFreshnessNote:
      "Vibe2Nite links to official sources where live times, duty rotas, warnings or council notices can change.",
    lastVerified: USEFUL_SERVICES_OFFICIAL_HELP_LAST_VERIFIED,
    serviceType: "overview",
    destination: "Benalmádena",
  },
  {
    id: "bus",
    path: "/benalmadena-bus-times",
    h1: "Benalmádena Bus Times",
    eyebrow: "Useful Services",
    icon: "🚌",
    intro:
      "Use this page as a quick tourist starting point for Benalmádena buses. Timetables can change, so always check the official live source before travelling.",
    answer:
      "Benalmádena urban and interurban bus information is published through local transport and the Málaga metropolitan transport network. Check current lines, stops and times before you travel.",
    quickSteps: [
      "Open the official line finder before travelling.",
      "Check the direction, stop name and latest departure time.",
      "For late nights or awkward routes, compare the journey with taxi options.",
    ],
    guidance: [
      "For local routes, start with Benalmádena transport links and the Málaga metropolitan transport line finder.",
      "Allow extra time in summer, during events, roadworks or local fiestas.",
      "If you are travelling late at night, compare bus options with taxi availability.",
    ],
    officialSourceLabel: "Consorcio de Transporte Metropolitano del Área de Málaga - lines",
    officialSourceUrl: "https://consorciotransporte-malaga.com/lineas/",
    secondarySourceLabel: "Benalmádena council mobility and transport",
    secondarySourceUrl: "https://www.benalmadena.es/delegacion-de-movilidad-y-transporte.html",
    ctaLabel: "Check live bus information",
    sourceFreshnessNote: "Bus stops, routes and timetable notices can change. Use the official live source before travelling.",
    lastVerified: USEFUL_SERVICES_LAST_VERIFIED,
    serviceType: "bus",
    destination: "Benalmádena",
    faqs: [
      {
        question: "Where do I check current bus times in Benalmádena?",
        answer:
          "Use the official Málaga metropolitan transport line finder or Benalmádena transport links, then confirm the exact stop and time before travelling.",
      },
      {
        question: "Can bus times change?",
        answer:
          "Yes. Timetables, stops and services can change because of seasonality, events, roadworks or local notices, so Vibe2Nite links to the official source for live information.",
      },
    ],
    relatedLinks: [
      { label: "Train", path: "/benalmadena-train-times" },
      { label: "Taxi", path: "/benalmadena-taxis" },
      { label: "What's On Tonight", path: "/tonight-benalmadena" },
    ],
  },
  {
    id: "train",
    path: "/benalmadena-train-times",
    h1: "Benalmádena Train Times",
    eyebrow: "Useful Services",
    icon: "🚆",
    intro:
      "The Cercanías C1 line connects Benalmádena-Arroyo de la Miel with Málaga, Málaga Airport, Torremolinos and Fuengirola.",
    answer:
      "For many visitors, the C1 train is the simplest public transport link between Benalmádena, Málaga Airport and the Costa del Sol. Check Renfe or official airport transport pages for current times.",
    quickSteps: [
      "Use Benalmádena-Arroyo de la Miel station for the central Benalmádena train stop.",
      "Check Renfe for current C1 times before leaving.",
      "Use taxi if your hotel or venue is far from the station, late at night or uphill.",
    ],
    guidance: [
      "Use Benalmádena-Arroyo de la Miel station for central Arroyo and many visitor areas.",
      "Aena lists the C1 as the train line serving Málaga Airport, with an approximate Benalmádena-airport journey time of 18 minutes.",
      "Check Renfe for real departure times, fares and service notices before travelling.",
    ],
    officialSourceLabel: "Renfe Cercanías Málaga",
    officialSourceUrl: "https://www.renfe.com/es/en/cercanias/cercanias-malaga",
    secondarySourceLabel: "Aena Málaga Airport train information",
    secondarySourceUrl: "https://www.aena.es/en/malaga-costa-del-sol/getting-there/trains.html",
    ctaLabel: "Check official train information",
    sourceFreshnessNote: "Train times and disruptions are live transport information, so Vibe2Nite links to official sources.",
    mapDestination: {
      name: "Benalmádena-Arroyo de la Miel train station",
      address: "Benalmádena-Arroyo de la Miel train station, Benalmádena, Spain",
      area: "Arroyo de la Miel",
    },
    lastVerified: USEFUL_SERVICES_LAST_VERIFIED,
    serviceType: "train",
    destination: "Benalmádena",
    faqs: [
      {
        question: "Which train serves Benalmádena?",
        answer:
          "Benalmádena is served by the Cercanías Málaga C1 line between Málaga Centro Alameda and Fuengirola.",
      },
      {
        question: "Can I take the train from Benalmádena to Málaga Airport?",
        answer:
          "Yes. The C1 line serves Málaga Airport. Aena lists an approximate Benalmádena to airport journey time of 18 minutes, but travellers should check current times.",
      },
    ],
    relatedLinks: [
      { label: "Airport", path: "/benalmadena-to-malaga-airport" },
      { label: "Bus", path: "/benalmadena-bus-times" },
      { label: "Restaurants", path: "/restaurants-benalmadena" },
    ],
  },
  {
    id: "taxi",
    path: "/benalmadena-taxis",
    h1: "Benalmádena Taxis",
    eyebrow: "Useful Services",
    icon: "🚕",
    intro:
      "For late nights, airport transfers or door-to-door trips, taxis are often the easiest option in Benalmádena.",
    answer:
      "Radio Taxi Benalmádena provides official local taxi contact information. Use the official taxi site for current phone numbers, taxi ranks and approximate fares.",
    quickSteps: [
      "Use the official taxi site for current phone or WhatsApp booking details.",
      "Book early for airport transfers, late-night returns or busy summer evenings.",
      "Ask about fare guidance before longer trips if you are unsure.",
    ],
    guidance: [
      "Radio Taxi Benalmádena lists 952 441 545 for phone bookings and +34 608 275 337 for WhatsApp reservations.",
      "Ask the driver or official taxi service about fares before longer trips if you are unsure.",
      "At busy times, book early or walk to an official taxi rank where practical.",
    ],
    officialSourceLabel: "Radio Taxi Benalmádena",
    officialSourceUrl: "https://www.benalmadenataxi.es/index.php",
    secondarySourceLabel: "Radio Taxi Benalmádena contact page",
    secondarySourceUrl: "https://www.benalmadenataxi.es/contacto",
    phoneNumber: "+34952441545",
    ctaLabel: "Open official taxi information",
    sourceFreshnessNote: "Taxi phone numbers, fares and rank information should be checked on the official taxi source.",
    lastVerified: USEFUL_SERVICES_LAST_VERIFIED,
    serviceType: "taxi",
    destination: "Benalmádena",
    faqs: [
      {
        question: "Where can I find a taxi in Benalmádena?",
        answer:
          "Use official taxi ranks or contact Radio Taxi Benalmádena. Their official site lists phone booking and WhatsApp reservation details.",
      },
      {
        question: "Are taxis useful after a night out?",
        answer:
          "Yes. Taxis are often the most practical option for late-night journeys when bus or train services are limited.",
      },
    ],
    relatedLinks: [
      { label: "Airport", path: "/benalmadena-to-malaga-airport" },
      { label: "What's On Tonight", path: "/tonight-benalmadena" },
      { label: "Bars", path: "/bars-benalmadena" },
    ],
  },
  {
    id: "airport",
    path: "/benalmadena-to-malaga-airport",
    h1: "Benalmádena to Málaga Airport",
    eyebrow: "Useful Services",
    icon: "✈️",
    intro:
      "Málaga-Costa del Sol Airport is connected to Benalmádena by train, taxi and selected bus/coach routes depending on where you start.",
    answer:
      "The C1 train is commonly the simplest public transport option between Benalmádena and Málaga Airport. Aena also publishes official bus, train and taxi information for the airport.",
    quickSteps: [
      "Check C1 train times if you are near Arroyo de la Miel station.",
      "Use taxi for early flights, late arrivals, luggage or accommodation away from the station.",
      "Open Aena for current airport transport options before travelling.",
    ],
    guidance: [
      "Aena lists the C1 train line for Málaga Airport and shows Benalmádena as an approximate 18-minute train journey from the airport.",
      "Taxi may be easier for early flights, late arrivals, heavy luggage or accommodation away from the train station.",
      "Check the official Aena airport transport pages before travelling because routes, fares and frequencies can change.",
    ],
    officialSourceLabel: "Aena Málaga Airport transport information",
    officialSourceUrl: "https://www.aena.es/en/malaga-costa-del-sol.html",
    secondarySourceLabel: "Aena airport train information",
    secondarySourceUrl: "https://www.aena.es/en/malaga-costa-del-sol/getting-there/trains.html",
    ctaLabel: "Check official airport transport",
    sourceFreshnessNote: "Airport transport, delays and service notices are live operational information from Aena and operators.",
    mapDestination: {
      name: "Málaga-Costa del Sol Airport",
      address: "Málaga-Costa del Sol Airport, Málaga, Spain",
      area: "Málaga Airport",
    },
    lastVerified: USEFUL_SERVICES_LAST_VERIFIED,
    serviceType: "airport",
    destination: "Málaga Airport",
    faqs: [
      {
        question: "How do I get from Benalmádena to Málaga Airport?",
        answer:
          "Most visitors compare the C1 train, taxi and bus/coach options. The C1 train is often the simplest public transport route, but check official times before travelling.",
      },
      {
        question: "Should I use taxi or train for the airport?",
        answer:
          "Use the train if times and station location suit you. Use a taxi for early flights, late arrivals, lots of luggage or door-to-door convenience.",
      },
    ],
    relatedLinks: [
      { label: "Train", path: "/benalmadena-train-times" },
      { label: "Taxi", path: "/benalmadena-taxis" },
      { label: "Bus", path: "/benalmadena-bus-times" },
    ],
  },
  {
    id: "pharmacy",
    path: "/pharmacies-benalmadena",
    h1: "Pharmacies in Benalmádena",
    eyebrow: "Useful Services",
    icon: "💊",
    intro:
      "Pharmacy opening hours and on-duty pharmacies change. Use Vibe2Nite for guidance, then check the official pharmacy duty source for current information.",
    answer:
      "For urgent or out-of-hours pharmacy needs, check the official Farmacéuticos de guardia search for Málaga province and select Benalmádena or the relevant local area.",
    quickSteps: [
      "Open the official on-duty pharmacy search.",
      "Choose Málaga province and the relevant town or area for today's date.",
      "For medical emergencies, use emergency services rather than relying on a pharmacy page.",
    ],
    guidance: [
      "Do not rely on old screenshots or cached opening times for medical needs.",
      "For emergencies, use official emergency services rather than a tourist guide website.",
      "Search by population and date on the official pharmacy duty page.",
    ],
    officialSourceLabel: "Farmacéuticos - Farmacias de guardia",
    officialSourceUrl: "https://farmaciasguardia.farmaceuticos.com/web_guardias/publico/Provincia_pNew.asp?id=29",
    ctaLabel: "Check on-duty pharmacies",
    sourceFreshnessNote: "Pharmacy duty rotas are date-sensitive; always use the official search for the day you need.",
    lastVerified: USEFUL_SERVICES_LAST_VERIFIED,
    serviceType: "pharmacy",
    destination: "Benalmádena",
    faqs: [
      {
        question: "How do I find an on-duty pharmacy in Benalmádena?",
        answer:
          "Use the official Farmacéuticos de guardia search for Málaga province and choose the relevant population or area for the date you need.",
      },
      {
        question: "Does Vibe2Nite show live pharmacy availability?",
        answer:
          "Not in Phase 1. Vibe2Nite links to official sources because pharmacy duty rotas can change and should be checked live.",
      },
    ],
    relatedLinks: [
      { label: "Medical Help", path: "/medical-help-benalmadena" },
      { label: "Emergency Help", path: "/emergency-help-benalmadena" },
      { label: "Taxi", path: "/benalmadena-taxis" },
    ],
  },
  {
    id: "medical",
    path: "/medical-help-benalmadena",
    h1: "Medical Help in Benalmádena",
    eyebrow: "Useful Services",
    icon: "🏥",
    intro:
      "If you need medical help while visiting Benalmádena, start with official health and emergency sources. Vibe2Nite keeps this page practical and avoids guessing live medical availability.",
    answer:
      "For urgent danger or serious medical emergencies in Andalucía, use 112. For non-emergency health guidance, use official Andalusian health resources and confirm current service details directly.",
    quickSteps: [
      "For urgent danger or serious illness, call 112 immediately.",
      "For pharmacy needs, open the on-duty pharmacy page and check today's official rota.",
      "For non-emergency health information, use Salud Responde or official Andalusian health information.",
    ],
    guidance: [
      "Do not wait on a tourist website for urgent medical or safety help.",
      "Carry your hotel/accommodation address when asking for help or booking transport.",
      "Use taxis for urgent but non-emergency travel if public transport would be slow or confusing.",
    ],
    officialSourceLabel: "Salud Responde - Andalusian Health Service",
    officialSourceUrl: ANDALUCIA_SALUD_RESPONDE_SOURCE,
    secondarySourceLabel: "Emergency 112 Andalucía",
    secondarySourceUrl: ANDALUCIA_EMERGENCY_112_SOURCE,
    ctaLabel: "Open official health information",
    sourceFreshnessNote: "Health guidance can change; use official Junta de Andalucía and health service sources for current information.",
    lastVerified: USEFUL_SERVICES_OFFICIAL_HELP_LAST_VERIFIED,
    serviceType: "medical",
    destination: "Benalmádena",
    faqs: [
      {
        question: "What should I do in a medical emergency in Benalmádena?",
        answer:
          "Use 112 for serious emergencies in Andalucía. Vibe2Nite is only a visitor guide and is not an emergency service.",
      },
      {
        question: "Can Vibe2Nite tell me which clinic is open right now?",
        answer:
          "No. Vibe2Nite links to official health and emergency sources because medical opening information should be checked live with official providers.",
      },
    ],
    relatedLinks: [
      { label: "Emergency Help", path: "/emergency-help-benalmadena" },
      { label: "Pharmacy", path: "/pharmacies-benalmadena" },
      { label: "Taxi", path: "/benalmadena-taxis" },
    ],
  },
  {
    id: "emergency",
    path: "/emergency-help-benalmadena",
    h1: "Emergency Help in Benalmádena",
    eyebrow: "Useful Services",
    icon: "🆘",
    intro:
      "For emergencies, use official emergency services first. This page exists to help visitors recognise the right next step quickly.",
    answer:
      "112 is the emergency number for serious incidents in Andalucía. For non-urgent issues, use the right official service, your accommodation reception, your travel provider or local police guidance where appropriate.",
    quickSteps: [
      "In immediate danger or serious medical emergency, call 112.",
      "Know your accommodation name, street and nearby landmark before calling or asking for help.",
      "Use official sources and hotel/reception support for non-urgent visitor problems.",
    ],
    guidance: [
      "This page does not replace emergency services, police, ambulance, fire or official consular guidance.",
      "If you are out late, keep a taxi option available and avoid walking unfamiliar long routes alone.",
      "For lost property, travel disruption or non-urgent support, start with your accommodation or the relevant official service.",
    ],
    officialSourceLabel: "Emergency 112 Andalucía",
    officialSourceUrl: ANDALUCIA_EMERGENCY_112_SOURCE,
    secondarySourceLabel: "Medical Help in Benalmádena",
    secondarySourceUrl: "/medical-help-benalmadena",
    ctaLabel: "Open 112 Andalucía information",
    sourceFreshnessNote: "Emergency information must come from official services. Vibe2Nite keeps this as signposting only.",
    lastVerified: USEFUL_SERVICES_OFFICIAL_HELP_LAST_VERIFIED,
    serviceType: "emergency",
    destination: "Benalmádena",
    faqs: [
      {
        question: "What number do I call in an emergency in Benalmádena?",
        answer:
          "Call 112 for serious emergencies in Andalucía. Use official emergency services first, not a tourist guide page.",
      },
      {
        question: "Should I use Vibe2Nite for urgent help?",
        answer:
          "No. Vibe2Nite can signpost official sources, but urgent medical, police or fire situations need official emergency services.",
      },
    ],
    relatedLinks: [
      { label: "Medical Help", path: "/medical-help-benalmadena" },
      { label: "Taxi", path: "/benalmadena-taxis" },
      { label: "Useful Services", path: "/useful-services" },
    ],
  },
  {
    id: "weather",
    path: "/benalmadena-weather",
    h1: "Benalmádena Weather",
    eyebrow: "Useful Services",
    icon: "☀️",
    intro:
      "Weather affects beach plans, market mornings, walks, terrace dining and nights out. Use the official forecast before making plans.",
    answer:
      "AEMET, Spain's state meteorological agency, publishes official Benalmádena forecast information including hourly forecasts and warnings.",
    quickSteps: [
      "Check AEMET before outdoor plans, markets or coastal walks.",
      "Look for heat, wind, rain and warning updates.",
      "Confirm outdoor events directly with the venue when weather looks uncertain.",
    ],
    guidance: [
      "Check AEMET for heat, wind, rain and weather warning updates.",
      "In summer, plan markets and walks earlier in the day when possible.",
      "For outdoor events or beach bars, confirm directly with the venue if weather looks uncertain.",
    ],
    officialSourceLabel: "AEMET Benalmádena hourly forecast",
    officialSourceUrl: "https://www.aemet.es/en/eltiempo/prediccion/municipios/horas/tabla/benalmadena-id29025",
    ctaLabel: "Check official weather",
    sourceFreshnessNote: "Weather is live information and can change quickly near the coast.",
    lastVerified: USEFUL_SERVICES_LAST_VERIFIED,
    serviceType: "weather",
    destination: "Benalmádena",
    faqs: [
      {
        question: "Where can I check official Benalmádena weather?",
        answer:
          "Use AEMET's Benalmádena forecast page for official Spanish meteorological information and warning updates.",
      },
      {
        question: "Can weather affect markets or outdoor venues?",
        answer:
          "Yes. Outdoor markets, beach plans and terrace venues can be affected by heat, wind or rain, so check current forecasts and official notices.",
      },
    ],
    relatedLinks: [
      { label: "Markets", path: "/markets-benalmadena" },
      { label: "Beach Bars", path: "/beach-bars-benalmadena" },
      { label: "What's On Tonight", path: "/tonight-benalmadena" },
    ],
  },
  {
    id: "markets",
    path: "/markets-benalmadena",
    h1: "Benalmádena Market Days",
    eyebrow: "Useful Services",
    icon: "🛍️",
    intro:
      "Find the main Benalmádena market days, where they are held, what type of market they are and where to check current changes.",
    answer:
      "Benalmádena council lists Friday markets, a Wednesday second-hand market and an ecological market on the third Sunday of each month. Market times and arrangements can change, so always check current council notices before making a special trip.",
    quickSteps: [
      "Use the date checker for the usual recurring market pattern.",
      "Open the official council source before making a special trip.",
      "Use directions for the exact market location and compare bus, train or taxi options.",
    ],
    guidance: [
      "Friday is the main market day, with listings for the Explanada de Tívoli and Recinto Ferial La Paloma.",
      "Wednesday is listed for second-hand products at Recinto Ferial La Paloma.",
      "The ecological market is listed as the third Sunday of each month at Recinto Ferial La Paloma.",
      "Weather, local events, public holidays or council notices can affect market operation.",
    ],
    officialSourceLabel: "Benalmádena council commerce information",
    officialSourceUrl: BENALMADENA_COUNCIL_MARKETS_SOURCE,
    ctaLabel: "Check official market information",
    sourceFreshnessNote: "Market days are recurring council information, but cancellations and changes must be checked with official notices.",
    lastVerified: USEFUL_SERVICES_LAST_VERIFIED,
    serviceType: "markets",
    destination: "Benalmádena",
    markets: BENALMADENA_MARKETS,
    faqs: [
      {
        question: "What days are the markets in Benalmádena?",
        answer:
          "Benalmádena council lists Friday markets, a Wednesday second-hand market and an ecological market on the third Sunday of each month. Always check current official notices before travelling.",
      },
      {
        question: "Where is the Benalmádena market?",
        answer:
          "Council information lists market locations including Explanada de Tívoli on Avenida del Manantial and Recinto Ferial La Paloma in Arroyo de la Miel.",
      },
      {
        question: "Is the Benalmádena market running today?",
        answer:
          "Use the date checker on this page for the usual recurring pattern, then confirm with the official council source because markets can change or be cancelled.",
      },
    ],
    relatedLinks: [
      { label: "Train", path: "/benalmadena-train-times" },
      { label: "Bus", path: "/benalmadena-bus-times" },
      { label: "Restaurants", path: "/restaurants-benalmadena" },
      { label: "What's On Tonight", path: "/tonight-benalmadena" },
    ],
  },
  {
    id: "tourist-info",
    path: "/tourist-information-benalmadena",
    h1: "Benalmádena Tourist Information",
    eyebrow: "Useful Services",
    icon: "ℹ️",
    intro:
      "Use this page as a practical visitor starting point for Benalmádena: areas, official tourist information, transport and what to explore next on Vibe2Nite.",
    answer:
      "Benalmádena is split across the coast, Arroyo de la Miel and the Pueblo, so tourists should check the exact area before walking. Vibe2Nite links visitor discovery with official tourism and transport information.",
    quickSteps: [
      "Check whether your plan is on the coast, in Arroyo de la Miel or uphill in Benalmádena Pueblo.",
      "Use the official tourist information source for civic visitor details.",
      "Use Vibe2Nite area, venue and transport pages to plan what to do next.",
    ],
    guidance: [
      "Benalmádena Costa, Arroyo de la Miel and Benalmádena Pueblo can feel close on a map but may need taxi, bus or train depending on where you start.",
      "For nights out, plan the return route before you leave your accommodation.",
      "Use Vibe2Nite destination guides for area feel, then official sources for live transport or civic information.",
    ],
    officialSourceLabel: "Benalmádena official tourism",
    officialSourceUrl: BENALMADENA_TOURISM_SOURCE,
    secondarySourceLabel: "Useful Services overview",
    secondarySourceUrl: "/useful-services",
    ctaLabel: "Open official tourist information",
    sourceFreshnessNote: "Official tourism information is linked rather than copied so visitors can verify current civic details.",
    mapDestination: {
      name: "Benalmádena tourist information",
      address: "Oficina de Turismo de Benalmádena, Benalmádena, Spain",
      area: "Benalmádena",
    },
    lastVerified: USEFUL_SERVICES_OFFICIAL_HELP_LAST_VERIFIED,
    serviceType: "tourist-info",
    destination: "Benalmádena",
    faqs: [
      {
        question: "Where should visitors start in Benalmádena?",
        answer:
          "Start by deciding whether you are exploring Benalmádena Costa, Arroyo de la Miel or Benalmádena Pueblo, then use official tourism and Vibe2Nite area guides together.",
      },
      {
        question: "Can I walk everywhere in Benalmádena?",
        answer:
          "Not always. Some areas are uphill or spread out, so check transport, taxi and train options before assuming a walk is practical.",
      },
    ],
    relatedLinks: [
      { label: "Destinations", path: "/destinations" },
      { label: "Bus", path: "/benalmadena-bus-times" },
      { label: "Train", path: "/benalmadena-train-times" },
      { label: "Taxi", path: "/benalmadena-taxis" },
    ],
  },
];

export const USEFUL_SERVICE_PAGES = USEFUL_SERVICE_CONTENT.map((page) => {
  const seo = getStaticSeoPage(page.path);
  if (!seo) throw new Error(`Missing static SEO registry entry for ${page.path}`);
  return { ...page, title: seo.title, description: seo.description };
});

export const USEFUL_SERVICE_PAGE_BY_PATH = Object.fromEntries(
  USEFUL_SERVICE_PAGES.map((page) => [page.path, page])
);

export const USEFUL_SERVICE_PAGE_BY_ID = Object.fromEntries(
  USEFUL_SERVICE_PAGES.map((page) => [page.id, page])
);

export const USEFUL_SERVICE_PAGE_PATHS = USEFUL_SERVICE_PAGES.map((page) => page.path);

export function getUsefulServicePageByPath(pathname) {
  return USEFUL_SERVICE_PAGE_BY_PATH[pathname] || null;
}

export function getUsefulServiceById(id) {
  return USEFUL_SERVICE_PAGE_BY_ID[id] || null;
}

function toLocalDate(value) {
  if (value instanceof Date) return value;
  return new Date(`${value || new Date().toISOString().slice(0, 10)}T12:00:00`);
}

function isThirdSunday(date) {
  if (date.getDay() !== 0) return false;
  const dayOfMonth = date.getDate();
  return dayOfMonth >= 15 && dayOfMonth <= 21;
}

export function isMarketOnDate(market, value) {
  const date = toLocalDate(value);
  const weekday = date.getDay();

  if (!market.weekdays?.includes(weekday)) return false;
  if (market.recurrence === "third_sunday") return isThirdSunday(date);

  return true;
}

export function marketsForDate(value, markets = BENALMADENA_MARKETS) {
  return markets.filter((market) => isMarketOnDate(market, value));
}

export function todayIsoDate() {
  return new Date().toISOString().slice(0, 10);
}
